import { Box, CircularProgress } from '@mui/material';
import React from 'react';

const AppLoader = ({ height = '100vh' }) => {
  return (
    <Box height={height} width='100%' display='flex' justifyContent='center' alignItems='center'>
      <CircularProgress size={40} />
    </Box>
  );
};

export default AppLoader;
